import { Skeleton } from "@mui/material";
import {
	CartSkeletonCard,
	CartSkeletonTotalCard,
	ViewCartSkeletonWrapper
} from "features/MarketingMaterials/pages/Checkout/components/ViewCartSkeleton/ViewCartSkeleton.styles.ts";

export const ViewCartSkeleton = () => {
	return (
		<ViewCartSkeletonWrapper>
			<CartSkeletonCard>
				<Skeleton
					variant="rectangular"
					height="120px"
				/>
			</CartSkeletonCard>
			<CartSkeletonTotalCard>
				<Skeleton
					variant="rectangular"
					height="98px"
				/>
			</CartSkeletonTotalCard>
		</ViewCartSkeletonWrapper>
	);
};
